var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }
      ],
      staticClass: "nav vue-warning"
    },
    [
      _c("Modal", {
        staticClass: "vue-warning__modal",
        attrs: {
          visible: _vm.visible,
          title: "VUE Update",
          description: _vm.description,
          clickClose: _vm.acknowledgeWarning,
          hasCloseBtn: !_vm.isFinalWarning
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function() {
              return [_vm._v(" " + _vm._s(_vm.message) + " ")]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _vm.isFinalWarning
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-default button-small",
                        on: { click: _vm.refreshPage }
                      },
                      [_vm._v(" Refresh ")]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "btn btn-default button-small",
                        on: { click: _vm.acknowledgeWarning }
                      },
                      [_vm._v(" Ok ")]
                    )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }